import { Routes } from '@angular/router';

export const sectionsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/sections/sections.component').then(c => c.SectionsComponent),
    data: { pageTitle: 'PAGES.SECTIONS.TITLE', pageType: 'list' }
  },
  {
    path: 'add',
    loadComponent: () => import('./pages/add-section/add-section.component').then(c => c.AddSectionComponent),
    data: { pageTitle: 'PAGES.SECTIONS.ADD', pageType: 'add' }
  },
  {
    path: 'edit-card/:id',
    loadComponent: () => import('./components/add-edit-card/add-edit-card.component').then(c => c.AddEditCardComponent),
    data: { pageTitle: 'PAGES.SECTIONS.EDIT_CARD', pageType: 'edit' }
  },
  {
    path: 'edit-tabs/:id',
    loadComponent: () => import('./components/add-edit-tabs/add-edit-tabs.component').then(c => c.AddEditTabsComponent),
    data: { pageTitle: 'PAGES.SECTIONS.EDIT_TABS', pageType: 'edit' }
  },
  {
    path: 'edit-collapse/:id',
    loadComponent: () => import('./components/add-edit-collapse/add-edit-collapse.component').then(c => c.AddEditCollapseComponent),
    data: { pageTitle: 'PAGES.SECTIONS.EDIT_COLLAPSE', pageType: 'edit' }
  },
  {
    path: 'edit-slider/:id',
    loadComponent: () => import('./components/add-edit-slider/add-edit-slider.component').then(c => c.AddEditSliderComponent),
    data: { pageTitle: 'PAGES.SECTIONS.EDIT_SLIDER', pageType: 'edit' }
  },
  {
    path: 'edit-statistics/:id',
    loadComponent: () => import('./components/add-edit-statistics/add-edit-statistics.component').then(c => c.AddEditStatisticsComponent),
    data: { pageTitle: 'PAGES.SECTIONS.EDIT_STATISTICS', pageType: 'edit' }
  },
  {
    path: 'edit-list/:id',
    loadComponent: () => import('./components/add-edit-list/add-edit-list.component').then(c => c.AddEditListComponent),
    data: { pageTitle: 'PAGES.SECTIONS.EDIT_LIST', pageType: 'edit' }
  },
  {
    path: 'edit-modal/:id',
    loadComponent: () => import('./components/add-edit-modal/add-edit-modal.component').then(c => c.AddEditModalComponent),
    data: { pageTitle: 'PAGES.SECTIONS.EDIT_MODAL', pageType: 'edit' }
  },
  {
    path: 'edit-forms/:id',
    loadComponent: () => import('./components/add-edit-forms/add-edit-forms.component').then(c => c.AddEditFormsComponent),
    data: { pageTitle: 'PAGES.SECTIONS.EDIT_FORMS', pageType: 'edit' }
  },
  {
    path: 'edit-gallery-album/:id',
    loadComponent: () => import('./components/add-edit-gallery-album/add-edit-gallery-album.component').then(c => c.AddEditGalleryAlbumComponent),
    data: { pageTitle: 'PAGES.SECTIONS.EDIT_GALLERY_ALBUM', pageType: 'edit' }
  }
];

